import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'

import BookingDetailsSummaryBlock from './BookingDetailsSummaryBlock'
import BookingPaymentFeeInfoModal from './paymentFee/BookingPaymentFeeInfoModal'

const BookingAdminBlock = ({ booking }) => {
  const { msg } = useIntl({
    scope: 'bookingAdminBlock',
    ignoreGlobalScope: false
  })
  let paymentMethod = null
  if (_.get(booking.payment, 'adminPaymentMethod')) {
    paymentMethod = booking.payment.adminPaymentMethod
  } else if (_.get(booking.payment, 'transactionGateway') === 'wallet_card') {
    paymentMethod = msg({ id: 'walletCard' })
  } else {
    paymentMethod = msg({ id: 'gateway' })
  }

  return (
    <BookingDetailsSummaryBlock
      className="BookingAdminBlock"
      title={msg({ id: 'title' })}
    >
      <div>
        {_.get(booking.payment, 'paymentFee') && (
          <BookingPaymentFeeInfoModal
            paymentFee={booking.payment.paymentFee}
            currency={booking.payment.currency}
          />
        )}
        {booking.payment && (
          <>
            <div>
              <span style={{ fontWeight: 'bold' }}>
                {msg({ id: 'paymentMethod' })}:&nbsp;
              </span>
              <span>{paymentMethod}</span>
            </div>
            {_.get(booking.payment, 'adminPaymentEmail') && (
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  {msg({ id: 'managedBy' })}:&nbsp;
                </span>
                <span>{booking.payment.adminPaymentEmail}</span>
              </div>
            )}
          </>
        )}
      </div>
    </BookingDetailsSummaryBlock>
  )
}

BookingAdminBlock.propTypes = {
  booking: PropTypes.shape()
}

BookingAdminBlock.displayName = 'BookingAdminBlock'

export default BookingAdminBlock
